import React from 'react'
import { DateTime } from 'luxon'

interface DayCellProps {
  day: DateTime
  isInCurrentMonth: boolean
  isToday: boolean
  overflowCount: number
  fitToHeight?: boolean
  children: React.ReactNode // spacer (pills are rendered in the overlay above)
}

const DayCell: React.FC<DayCellProps> = ({ day, isInCurrentMonth, isToday, overflowCount, fitToHeight, children }) => {
  const dayNumberClasses = [
    'text-sm leading-none',
    isInCurrentMonth ? 'text-body' : 'text-faint',
    isToday
      ? 'inline-flex items-center justify-center w-6 h-6 rounded-full bg-orange text-on-solid font-semibold'
      : 'inline-flex items-center justify-center w-6 h-6'
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={`relative flex flex-col p-1 border-r border-b border-divider ${
        fitToHeight ? 'min-h-0 overflow-hidden' : 'min-h-[140px]'
      } ${isInCurrentMonth ? 'bg-surface' : 'bg-surface-muted'}`}
    >
      <div className="flex items-center">
        <span className={dayNumberClasses}>{day.day}</span>
      </div>
      {children}
      {overflowCount > 0 && (
        <div className="text-xs text-muted px-2 mt-0.5 pointer-events-none">{overflowCount} more…</div>
      )}
    </div>
  )
}

export default DayCell
